/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SecurityLockOpenIcon32Regular = forwardRef('SecurityLockOpenIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M25 1a7 7 0 0 0-7 7v1a1 1 0 1 0 2 0V8a5 5 0 0 1 10 0v1a1 1 0 1 0 2 0V8a7 7 0 0 0-7-7Z" }),
        React.createElement("path", { d: "M14 20.76a2.2 2.2 0 1 0-2 0V23a1 1 0 1 0 2 0v-2.24Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 16a5 5 0 0 1 5-5h14a5 5 0 0 1 5 5v8a5 5 0 0 1-5 5H6a5 5 0 0 1-5-5v-8Zm5-3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-8a3 3 0 0 0-3-3H6Z" })));
});
